import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import { Link } from "react-router-dom";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import ToolTips from "./ToolTips";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "react-select";
import Common from "./../../common.json";
import Faq from "./Faq";

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: "16px 0", //theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  setSelect: {
    width: "150px",
    display: "inline-block",
    marginRight: "10px",
  },
  customeRow: { fontSize: "12px", color: "#fff" },
  reactTooltip: { zIndex: 100, backgroundColor: "#007bff !important" },
  highlighttext: { fontWeight: "bold", color: "#fff", cursor: "pointer" },
}));

export default function Index() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [userStatus, setUserStatus] = useState(-1);
  const [action, setAction] = useState("");
  const [filter, setFilter] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [pageStatus, setPageStatus] = useState({});
  const [value, setValue] = React.useState({
    value: "1",
    label: "Advertising",
  });
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";

  const handleChange = (event) => {
    setValue(event);
  };

  useEffect(() => {
    setLoading(true);
    RestService.getHeatMapData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data);
        setUserStatus(response.data?.userStatus);
        setPageStatus(response.data?.pageStatus);
        setErrorMessage("No Record Found");
      },
      mobile,
      web_token,
      value?.value,
      action,
      filter
    );
  }, [mobile, web_token, value, action, filter]);

  const updateFilter = (filter1, filter2) => {
    const combineFilter = `${filter1},${filter2}`;
    if (filter === combineFilter) {
      setFilter("");
    } else {
      setFilter(combineFilter);
    }
  };

  const getrecordByFIlter = (type) => {
    let fundamental = pageStatus.find((item) => item.pageid === "31");
    let technical = pageStatus.find((item) => item.pageid === "32");
    let fAndo = pageStatus.find((item) => item.pageid === "33");
    let chart = pageStatus.find((item) => item.pageid === "35");
    if (userStatus > 0) {
      setAction(type);
    } else if (type === "fundamental" && parseInt(fundamental?.stauts) === 0) {
      setOpen(true);
    } else if (type === "technical" && parseInt(technical.status) === 0) {
      setOpen(true);
    } else if (type === "fnO" && parseInt(fAndo.status) === 0) {
      setOpen(true);
    } else if (type === "chart" && parseInt(chart.status) === 0) {
      setOpen(true);
    } else {
      setAction(type);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <GlobalHelmet {...Common?.heatMap} />
      {loading ? <Loader /> : ""}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Subscripton</DialogTitle>
        <DialogContent>
          <DialogContentText>To Enjoy service make payemnt</DialogContentText>

          <div></div>
        </DialogContent>
        <DialogActions>
          <button onClick={handleClose} className="btn btn-default">
            Cancel
          </button>
          <Link className="btn btn-success" to="/subscription" target="_blank">
            Make Payment
          </Link>
        </DialogActions>
      </Dialog>
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-md-12">
              <div className="fixedAddButton"></div>
              <Breadcrumbs page="HeatMap" />
            </div>
            <div className="col-md-12">
              <h1 className="highlighttext">Nifty Heatmap</h1>
              <p>
                Get the heatmap for NSE stocks with live share price of stocks,
                percentage change, volume analysis, % delivery volume, buy sell
                signal & stock entry price levels. Explore nifty 50 heatmap,
                bank nifty heatmap, F&O heatmap & other sector heat map to get
                fundamental analysis, technical analysis and open interest
                analysis in a quick way. On this nse heatmap live, get technical
                analysis & fundamental analysis in the easiest way. Analyze the
                future & option data like open interest analysis, no of trades,
                stocks future price, open interest etc for F&O stocks.
              </p>
            </div>
            <div className="col-md-12">
              <div className=" onerowsync">
                <div className="row">
                  <div className="col-sm-12 mb-4">
                    <button
                      onClick={() => updateFilter(5, 5)}
                      className={
                        filter === "5,5"
                          ? "btn btn-above-5 ml-2 mt-2"
                          : "btn btn-default ml-2 mt-2"
                      }
                    >
                      Above +5%
                    </button>
                    <button
                      onClick={() => updateFilter(2, 5)}
                      className={
                        filter === "2,5"
                          ? "btn btn-above-2-5 ml-2 mt-2"
                          : "btn btn-default ml-2 mt-2"
                      }
                    >
                      +2 to +5%
                    </button>
                    <button
                      onClick={() => updateFilter(0, 2)}
                      className={
                        filter === "0,2"
                          ? "btn btn-above-0-2 ml-2 mt-2"
                          : "btn btn-default ml-2 mt-2"
                      }
                    >
                      0 to +2%
                    </button>
                    <button
                      onClick={() => updateFilter(0, -2)}
                      className={
                        filter === "0,-2"
                          ? "btn btn-below-0-2 ml-2 mt-2"
                          : "btn btn-default ml-2 mt-2"
                      }
                    >
                      0 to -2%
                    </button>
                    <button
                      onClick={() => updateFilter(-2, -5)}
                      className={
                        filter === "-2,-5"
                          ? "btn btn-below-2-5 ml-2 mt-2"
                          : "btn btn-default ml-2 mt-2"
                      }
                    >
                      -2 to -5%
                    </button>
                    <button
                      onClick={() => updateFilter(-5, -5)}
                      className={
                        filter === "-5,-5"
                          ? "btn btn-below-5 ml-2 mt-2"
                          : "btn btn-default ml-2 mt-2"
                      }
                    >
                      {" "}
                      Below -5%
                    </button>
                  </div>
                  <div className="col-12 text-right">
                    <Select
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      value={value}
                      onChange={handleChange}
                      menuPosition={"fixed"}
                      options={
                        globaldata?.sectorData ? globaldata?.sectorData : []
                      }
                      name="expiry_date"
                      className={classes.setSelect + " mr-2  select-option"}
                      placeholder="Select Sector"
                    />
                    <button
                      onClick={() => getrecordByFIlter("fundamental")}
                      className={
                        action === "fundamental"
                          ? "btn btn-success ml-2"
                          : "btn btn-default ml-2"
                      }
                    >
                      Fundamental
                    </button>
                    <button
                      onClick={() => getrecordByFIlter("technical")}
                      className={
                        action === "technical"
                          ? "btn btn-success ml-2"
                          : "btn btn-default ml-2"
                      }
                    >
                      Technical
                    </button>
                    <button
                      onClick={() => getrecordByFIlter("fnO")}
                      className={
                        action === "fnO"
                          ? "btn btn-success ml-2"
                          : "btn btn-default ml-2"
                      }
                    >
                      F&O
                    </button>
                    <button
                      onClick={() => getrecordByFIlter("chart")}
                      className={
                        action === "chart"
                          ? "btn btn-success ml-2"
                          : "btn btn-default ml-2"
                      }
                    >
                      Chart
                    </button>
                  </div>
                  <div className="col-12 mt-4">
                    <div className={classes.root}>
                      <Grid container spacing={2}>
                        {globaldata?.getDetails ? (
                          globaldata?.getDetails.map((items, key) => (
                            <Grid item key={key} xs={6} sm={4} md={4} lg={2}>
                              <Link
                                to={"/stocks/" + items.symbol}
                                target="_blank"
                                data-for={"tipid" + key}
                                data-tip={items.symbol}
                              >
                                <Paper
                                  className={
                                    "custom2-grid-style " + classes.paper
                                  }
                                  style={{
                                    backgroundColor: items?.background,
                                  }}
                                >
                                  <label
                                    className={classes.highlighttext}
                                    style={{ color: items?.color }}
                                  >
                                    {items.symbol}
                                  </label>

                                  <div
                                    className={classes.customeRow + " row"}
                                    style={{ color: items?.color }}
                                  >
                                    <div className="col-6">LTP: {items.l} </div>
                                    <div className="col-6">
                                      % Chg:
                                      <b> {items.cp}</b>
                                    </div>
                                    <div className="col-6">Vol: {items.vo}</div>
                                    <div className="col-6">
                                      %Del: {items.DELIV_PER}
                                    </div>
                                  </div>
                                </Paper>
                              </Link>

                              {action && (
                                <ReactTooltip
                                  id={"tipid" + key}
                                  className={classes.reactTooltip}
                                  place="bottom"
                                  action={action}
                                >
                                  <ToolTips action={action} items={items} />
                                </ReactTooltip>
                              )}
                            </Grid>
                          ))
                        ) : (
                          <></>
                        )}
                      </Grid>
                    </div>
                  </div>
                  <div className="col-12">
                    {!globaldata?.getDetails && ErrorMessage && (
                      <div className="alert alert-warning  " role="alert">
                        {ErrorMessage}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-4">
              <Faq />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
